import EyeDrawSection from '../EyeDrawSection';
import thumb1 from '../images/thumb_01.jpg';
import thumb2 from '../images/thumb_02.jpg';
import thumb3 from '../images/thumb_03.jpg';
import thumb4 from '../images/thumb_04.jpg';
import img1 from '../images/1.png';
import img2 from '../images/2.png';
import img3 from '../images/3.png';
import img4 from '../images/4.png';

const cards = [
    { title: 'Lids 3/4', thumb: thumb1, image: img1 },
    { title: 'Lids Front', thumb: thumb2, image: img2 },
    { title: 'Lids Profile', thumb: thumb3, image: img3 },
    { title: 'Lids Closeup', thumb: thumb4, image: img4 },
];

export default function EyeLids() {
    return <EyeDrawSection id="eye-lids" title="Eye Lids" icon="bi-eye" cards={cards} />;
}
